import { importDynamicModules } from "@nextories/vue-core-components/src/utils/helpers/format";

export default importDynamicModules(import.meta.glob("./*.ts", { eager: true }));
